<template>
  <tr>
    <td class="apply-width">
      <b-form-checkbox
        id="checkbox-1"
        v-model="status"
        name="checkbox-1"
        value="accepted"
        unchecked-value="not_accepted"
      >
      </b-form-checkbox>
    </td>
    <td class="apply-width">
      <span class="apply-fs">{{ objTest["AÑO"] }}</span>
    </td>
    <td class="apply-width"  colspan="2">
      <span class="apply-fs">{{ objTest.INICIATIVA }}</span>
    </td>
    <td class="apply-width">
      <span class="apply-fs">{{ objTest.ESTADO_AVANCE }}</span>
    </td>
    <!-- <td>
      <span>{{ objTest.ANIO }}</span>
    </td> -->
  </tr>
</template>
<script>
export default {
  props: ["objTest", "index", "handlerSelectedRow"],
  data() {
    return {
      status: "not_accepted",
    };
  },
  watch: {
    status: function(value){
      this.$emit("handlerSelectedRow", this.index, {
        AÑO: this.objTest.AÑO,
        ESTADO_AVANCE: this.objTest.ESTADO_AVANCE,
        INICIATIVA: this.objTest.INICIATIVA,
        MINISTERIO: this.objTest.MINISTERIO,
        PACA_MINISTERIO: this.objTest.PACA_MINISTERIO
      }, value);
    }
  }
};
</script>
<style scoped>
.apply-fs {
  font-size: 0.9rem;
}

td {
  text-align: left !important;
      width: 21%;
    color: blue
}
</style>
